module.exports = __webpack_public_path__ + "img/uptime-100.45cf0ed9.svg";